/* eslint-disable @typescript-eslint/no-empty-interface */
import { QueryFunctionContext } from 'react-query';
import { shareLightUrls } from 'utils/apiUrls';
import { HttpType } from 'utils/http';

export interface ShareLightPublicIdsResponse {
  submissionIds: string[];
}

export interface ShareLightSubmissionResponse {
    'submission': {
        'id': string,
        'email': string,
        'content': string,
        'likes': number,
        'title': string,
        'name': string
        'shares': number,
    }
}

// API service functions
export const submitShareLight = (method: HttpType['post']) => (payload: { email?: string; content: string; consent?: boolean, title: string, name: string, csrfToken?: string }) => method(shareLightUrls.submit.apiUrl().submit, { ...payload });

export const getShareLightPublicIds = (method: HttpType['get']) => (): Promise<ShareLightPublicIdsResponse> => method(shareLightUrls.publicIds.apiUrl().list, {});

export const getShareLightSubmission = (method: HttpType['get']) => function async({ queryKey }: QueryFunctionContext): Promise<ShareLightSubmissionResponse> {
  const [, submissionId] = queryKey;

  return (
    method(shareLightUrls.submission.apiUrl(submissionId as string).details, {})
  );
};

export const updateLikeCount = (method: HttpType['post']) => (id: string, likeStatus: 'LIKED' | 'DISLIKED', csrfToken?: string): Promise<void> => method(shareLightUrls.like.apiUrl().updateLikes, csrfToken ? { id, likeStatus, csrfToken } : { id, likeStatus });

export const updateShareCount = (method: HttpType['post']) => (id: string, csrfToken?: string): Promise<void> => method(shareLightUrls.share.apiUrl().share, csrfToken ? { id, csrfToken } : { id });

export const getCsrfToken = (method: HttpType['get']) => (): Promise<{ 'CSRF-Token': string }> => method(shareLightUrls.csrfToken.apiUrl().get, {});

export type Thought = {
  id: string;
  text: string;
  likes: number;
};

